
import StoryElement from "./StoryElement";
import StoryModelEvent from "./StoryModelEvent"

export default class StoryNode extends StoryElement {
    /**
     * @constructor
     * @param {StoryArc} storyArc
     * @param {number} id
     * @param {*} data
     * @param {LogicalExpression} unlockCondition
     * @param {LogicalExpression} availableCondition
     * @param {Boolean} isEnd
     */
    constructor(storyArc, id, data, unlockCondition, availableCondition, isEnd) {
        super(id, data, unlockCondition, availableCondition, isEnd);

        // .storyArc getter 
        this._storyArc = storyArc;
    }
    getStoryArc() {
        return this._storyArc;
    }
    /**
         * Dispatches an update event
         * @returns {undefined}
         */
    update() {
        this.dispatchEvent(StoryModelEvent.STORY_NODE_UPDATED, this);
    }
}



